<template>
    <div>
      <v-card color="transparent" flat>
        <v-toolbar color="transparent" flat>
          <v-toolbar-title class="font-weight-bold"
            >Animal Details</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            @click="$router.push({ name: 'GeneticsListV2' })"
            >Cancel</v-btn
          >
          <v-btn color="primary" class="ml-2" outlined @click="submitForm">
            {{ action == "create" ? "Save as Draft" : "Update" }}</v-btn
          >
          <v-btn
            color="primary"
            class="ml-2"
            depressed
            @click="updateAnimalEPDSubmitStatus"
            >Submit</v-btn
          >
        </v-toolbar>
      </v-card>
  
      <v-card
        class="mt-5 d-flex justify-space-between align-center mb-6"
        flat
        tile
      >
        <v-card flat>
          <v-list>
            <v-list-item>
              <v-list-item-avatar size="90" class="pa-0">
                <v-img :src="animalImg"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-subtitle> Animal ID </v-list-item-subtitle>
                <v-list-item-title class="font-weight-bold mt-2 text-capitalize">
                  {{ animal.animalNumber || "N/A" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
        <v-divider vertical inset></v-divider>
        <v-card flat>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle> Tag # </v-list-item-subtitle>
                <v-list-item-title class="font-weight-bold mt-2 text-capitalize">
                  # {{ animal.tagNumber || "N/A" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
        <v-divider vertical inset></v-divider>
        <v-card flat class="align-center" max-width="150">
          <v-list>
            <v-list-item>
              <v-list-item-content class="text-center">
                <v-list-item-subtitle> Date of Birth </v-list-item-subtitle>
                <v-list-item-title class="font-weight-bold mt-2 text-capitalize">
                  {{ animal.dob || "N/A" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
        <v-divider vertical inset></v-divider>
        <v-card flat>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle> Gender </v-list-item-subtitle>
                <v-list-item-title class="font-weight-bold mt-2 text-capitalize">
                  {{ animal.gender || "N/A" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
        <v-divider vertical inset></v-divider>
        <v-card flat>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle> Breed </v-list-item-subtitle>
                <v-list-item-title class="font-weight-bold mt-2 text-capitalize">
                  {{ epdV2.primaryBreed || "N/A" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
        <v-divider vertical inset></v-divider>
        <v-card flat>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle> Reg. Date </v-list-item-subtitle>
                <v-list-item-title class="font-weight-bold mt-2 text-capitalize">
                  {{ animal.createdAt || "N/A" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
        <v-divider vertical inset></v-divider>
        <v-card flat>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle> Status </v-list-item-subtitle>
                <v-list-item-title class="font-weight-bold mt-2 text-capitalize">
                  {{ animal.status || "N/A" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-card>
  
      <v-row>
        <v-col cols="3">
          <v-card flat>
            <v-stepper v-model="stepper" vertical flat>
              <template v-for="s in formSteps">
                <v-stepper-step
                  :key="s.step"
                  :complete="stepper > s.step"
                  :step="s.step"
                  class="vertical-steps"
                >
                  {{ s.name }}
                </v-stepper-step>
                <v-stepper-content :key="s.name" :step="s.step" class="py-10">
                  <v-card color="transparent" min-height="50"></v-card>
                </v-stepper-content>
              </template>
            </v-stepper>
          </v-card>
        </v-col>
        <v-col cols="9">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card flat>
              <v-stepper v-model="stepper" vertical flat>
                <v-stepper-content step="1" class="no-border" flat>
                  <v-card flat>
                    <v-toolbar
                      color="transparent"
                      flat
                      class="black--text topbar-border"
                    >
                      <v-toolbar-title class="font-weight-bold"
                        >Add Basic Information</v-toolbar-title
                      >
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <hr />
                    <v-card-text>
                      <v-row>
                        <!-- International ID -->
                        <v-col lg="4" md="6" sm="12" xs="12">
                          <label class="subtitle-1 black--text font-weight-medium"
                            >International ID
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.internationalID") }}</span>
                            </v-tooltip>
                          </label>
                          <v-text-field
                            dense
                            outlined
                            placeholder="Enter ID"
                            v-model="epdV2.internationalId"
                            maxlength="20"
                          ></v-text-field>
                        </v-col>
  
                        <!-- Animal Registration Number -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label class="subtitle-1 black--text font-weight-medium"
                            >Animal Registration
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.regNo") }}</span>
                            </v-tooltip>
                          </label>
                          <v-text-field
                            dense
                            outlined
                            v-model="animal.animalNumber"
                            disabled
                            placeholder="Animal Registration"
                          ></v-text-field>
                        </v-col>
  
                        <!-- Location -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label class="subtitle-1 black--text font-weight-medium"
                            >Location
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.location") }}</span>
                            </v-tooltip>
                          </label>
                          <v-text-field
                            dense
                            outlined
                            v-model="epdV2.location"
                            maxlength="25"
                            placeholder="Location"
                          ></v-text-field>
                        </v-col>
  
                        <!-- Animal Name -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                          >
                            Animal Name
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.animalName") }}</span>
                            </v-tooltip>
                          </label>
                          <v-text-field
                            dense
                            outlined
                            v-model="animal.name"
                            :disabled="!editMainData"
                            :error-messages="errors.name"
                            placeholder="Animal Name"
                          ></v-text-field>
                        </v-col>
  
                        <!-- Gender -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                            for="gender"
                          >
                            {{ $t("animal.gender") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.gender") }}</span>
                            </v-tooltip>
                          </label>
                          <v-select
                            :items="genders"
                            item-text="text"
                            item-value="value"
                            outlined
                            dense
                            v-model="animal.gender"
                            :disabled="!editMainData"
                            :error-messages="errors.gender"
                            :placeholder="$t('animal.gender')"
                          ></v-select>
                        </v-col>
  
                        <!-- Additional Identification Method -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium text-no-wrap"
                          >
                            {{ $t("Additional Identification Method") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon size="18" v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.additionalIDMethod") }}</span>
                            </v-tooltip>
                          </label>
                          <v-text-field
                            dense
                            outlined
                            v-model="animal.uniqueIdentifier"
                            :error-messages="errors.additionalIdMethod"
                            placeholder="Additional Identification Method"
                          ></v-text-field>
                        </v-col>
  
                        <!-- Conception Method -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                            for="conceptionMethod"
                            >{{ $t("animal.conceptionMethod") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.conceptionMethod") }}</span>
                            </v-tooltip>
                          </label>
                          <v-select
                            :items="conceptionMethod"
                            item-text="text"
                            item-value="text"
                            outlined
                            dense
                            v-model="animal.conceptionMethod"
                            :error-messages="errors.conceptionMethod"
                            :placeholder="$t('animal.conceptionMethod')"
                          ></v-select>
                        </v-col>
  
                        <!-- Dam ID -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                          >
                            Dam ID
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.damID") }}</span>
                            </v-tooltip>
                          </label>
                          <!-- <v-text-field 
                                                  dense 
                                                  outlined 
                                                  v-model="epdV2.damId"
                                                  :error-messages="errors.damId"
                                                  placeholder="Dam ID"
                                              ></v-text-field> -->
                          <AnimalDropdown
                            v-model="animal.damPubId"
                            animalType="dam"
                            :currentAnimal="$route.params.geneticid || null"
                          />
                        </v-col>
  
                        <!-- Sire ID -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                          >
                            Sire ID
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.sireId") }}</span>
                            </v-tooltip>
                          </label>
                          <!-- <v-text-field 
                                                  dense 
                                                  outlined 
                                                  v-model="epdV2.sireId" 
                                                  :error-messages="errors.sireId"
                                                  placeholder="Sire ID"
                                              ></v-text-field> -->
                          <AnimalDropdown
                            v-model="animal.sirePubId"
                            animalType="sire"
                            :currentAnimal="$route.params.geneticid || null"
                          />
                        </v-col>
  
                        <!-- Date Of Birth -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                            for="dob"
                          >
                            {{ $t("animal.dateOfBirth") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.dateOfBirth") }}</span>
                            </v-tooltip>
                          </label>
                          <v-menu
                            v-model="animalDOBmenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                @click:append="animalDOBmenu = true"
                                append-icon="mdi-calendar"
                                outlined
                                dense
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                v-model="animal.dob"
                                :error-messages="errors.dob"
                                :placeholder="$t('animal.dateOfBirth')"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="animal.dob"
                              :max="today"
                              @input="animalDOBmenu = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
  
                        <!-- Animal Status -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                            for="Animal Status"
                          >
                            {{ $t("Animal Status") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.animalStatus") }}</span>
                            </v-tooltip>
                          </label>
                          <v-select
                            :items="animalStatuses"
                            outlined
                            dense
                            v-model="animal.status"
                            :error-messages="errors.status"
                            :placeholder="$t('Animal Status')"
                          ></v-select>
                        </v-col>
                      </v-row>
                    </v-card-text>
  
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <!-- <v-btn outlined color="primary">
                                          Back
                                      </v-btn> -->
                      <v-btn color="primary" @click="stepper = 2" depressed>
                        Continue
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-stepper-content>
  
                <v-stepper-content step="2" class="no-border">
                  <v-card flat>
                    <v-toolbar color="transparent" flat class="black--text">
                      <v-toolbar-title class="font-weight-bold"
                        >Birth Weight Information</v-toolbar-title
                      >
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <hr />
                    <v-card-text>
                      <v-row>
                        <!-- Breeder Herd Code -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                          >
                            Breeder Herd Code
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.breederHerdCode") }}</span>
                            </v-tooltip>
                          </label>
                          <v-text-field
                            dense
                            :class="{
                              'required-field': epdRequiredFields.breeder_herd_code,
                            }"
                            :solo="epdRequiredFields.breeder_herd_code"
                            :outlined="!epdRequiredFields.breeder_herd_code"
                            flat
                            v-model="epdV2.breederHerdCode"
                            placeholder="Breeder Herd Code"
                            maxlength="10"
                          ></v-text-field>
                        </v-col>
  
                        <!-- Birth Year -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                            for="dob"
                          >
                            {{ $t("Birth Year") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.birthYear") }}</span>
                            </v-tooltip>
                          </label>
                          <v-menu
                            v-model="birthYearMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                :class="{
                                  'required-field': epdRequiredFields.birth_year_range,
                                }"
                                :solo="epdRequiredFields.birth_year_range"
                                :outlined="!epdRequiredFields.birth_year_range"
                                flat
                                @click:append="birthYearMenu = true"
                                append-icon="mdi-calendar"
                                dense
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                v-model="birthYear"
                                disabled
                                placeholder="Birth Year"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="birthYear"
                              @input="birthYearMenu = false"
                              type="year"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
  
                        <!-- Season of Birth -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label class="subtitle-1 black--text font-weight-medium"
                            >{{ $t("Season of Birth") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.seasonofBirth") }}</span>
                            </v-tooltip>
                          </label>
                          <v-select
                            :items="birthSeasons"
                            :class="{
                              'required-field': epdRequiredFields.season_of_birth,
                            }"
                            :solo="epdRequiredFields.season_of_birth"
                            :outlined="!epdRequiredFields.season_of_birth"
                            flat
                            item-text="text"
                            item-value="value"
                            dense
                            v-model="epdV2.seasonOfBirth"
                            placeholder="Select Season"
                          ></v-select>
                        </v-col>
  
                        <!-- Birth Sex -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                            for="gender"
                          >
                            {{ $t("Birth Sex") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("Birth Sex") }}</span>
                            </v-tooltip>
                          </label>
                          <v-select
                            :class="{
                              'required-field': epdRequiredFields.birth_sex,
                            }"
                            :solo="epdRequiredFields.birth_sex"
                            :outlined="!epdRequiredFields.birth_sex"
                            flat
                            :items="genders"
                            item-text="text"
                            item-value="value"
                            dense
                            v-model="animal.gender"
                            placeholder="Birth Sex"
                          ></v-select>
                        </v-col>
  
                        <!--  Primary Breed -->
                        <v-col lg="6" md="6" sm="6" xs="6">
                          <v-row>
                            <!--  Primary Breed -->
                            <v-col cols="6">
                              <label
                                class="subtitle-1 black--text font-weight-medium text-no-wrap"
                              >
                                {{ $t("Primary Breed") }}
                                <v-tooltip top color="black" max-width="350">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>{{ $t("epd.primaryBreed") }}</span>
                                </v-tooltip>
                              </label>
                              <v-autocomplete
                              placeholder="Select Breed"
                              flat
                              v-model="epdV2.primaryBreed"
                              :items="breeds"
                              :class="{
                                  'required-field':
                                    epdRequiredFields.B_primary_breed_composition,
                                }"
                                :solo="
                                  epdRequiredFields.B_primary_breed_composition
                                "
                                :outlined="
                                  !epdRequiredFields.B_primary_breed_composition
                                "
                              dense
                              item-text="name"
                              item-value="name"
                            >
                              <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                  <v-list-item-content v-text="data.item"></v-list-item-content>
                                </template>
                                <template v-else>
                                  <v-list-item-content>
                                    <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                  </v-list-item-content>
                                </template>
                              </template>
                            </v-autocomplete>
                            </v-col>
  
                            <!--  Primary Breed Composition-->
                            <v-col cols="6">
                              <label
                                class="subtitle-1 black--text font-weight-medium text-no-wrap"
                              >
                                {{ $t("Breed Composition") }}
                                <v-tooltip top color="black" max-width="350">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>{{ $t("epd.breedComposition") }}</span>
                                </v-tooltip>
                              </label>
                              <v-text-field
                                max="100"
                                v-model="breedComposition1"
                                @keypress="NumbersOnly"
                                :class="{
                                  'required-field':
                                    epdRequiredFields.B_primary_breed_composition,
                                }"
                                :solo="
                                  epdRequiredFields.B_primary_breed_composition
                                "
                                :outlined="
                                  !epdRequiredFields.B_primary_breed_composition
                                "
                                flat
                                dense
                                type="number"
                                min="0"
                                placeholder="e.g 80%"
                                :error-messages="wPBCerror"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>
  
                        <!-- Secondary Breed -->
                        <v-col lg="6" md="6" sm="6" xs="6">
                          <v-row class="d-flex">
                            <!-- Secondary Breed -->
                            <v-col cols="6">
                              <label
                                class="subtitle-1 black--text font-weight-medium"
                              >
                                {{ $t("Secondary Breed") }}
                                <v-tooltip top color="black" max-width="350">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>{{ $t("epd.secondaryBreed") }}</span>
                                </v-tooltip>
                              </label>
                              <v-autocomplete
                              placeholder="Select Breed"
                              flat
                              v-model="epdV2.secondaryBreed"
                              :items="breeds"
                              :class="{
                                  'required-field':
                                    epdRequiredFields.B_secondary_breed_composition,
                                }"
                                :solo="
                                  epdRequiredFields.B_secondary_breed_composition
                                "
                                :outlined="
                                  !epdRequiredFields.B_secondary_breed_composition
                                "
                              dense
                              item-text="name"
                              item-value="name"
                            >
                              <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                  <v-list-item-content v-text="data.item"></v-list-item-content>
                                </template>
                                <template v-else>
                                  <v-list-item-content>
                                    <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                  </v-list-item-content>
                                </template>
                              </template>
                            </v-autocomplete>
                            </v-col>
  
                            <!-- Secondary Breed Composition-->
                            <v-col cols="6">
                              <label
                                class="subtitle-1 black--text font-weight-medium"
                              >
                                {{ $t("Breed Composition") }}
                                <v-tooltip top color="black" max-width="350">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>{{ $t("epd.breedComposition") }}</span>
                                </v-tooltip>
                              </label>
                              <v-text-field
                                v-model="breedCompositionSecondary1"
                                @keypress="NumbersOnly"
                                :class="{
                                  'required-field':
                                    epdRequiredFields.B_secondary_breed_composition,
                                }"
                                :solo="
                                  epdRequiredFields.B_secondary_breed_composition
                                "
                                :outlined="
                                  !epdRequiredFields.B_secondary_breed_composition
                                "
                                flat
                                dense
                                type="number"
                                min="0"
                                max="100"
                                placeholder="e.g 20%"
                                :error-messages="wSBCerror"
                                
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>
  
                        <!--  Birth Management Code -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                          >
                            Birth Management Code
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.birthManagementCode") }}</span>
                            </v-tooltip>
                          </label>
                          <v-text-field
                            dense
                            :class="{
                              'required-field':
                                epdRequiredFields.birth_management_code,
                            }"
                            :solo="
                              epdRequiredFields.birth_management_code
                            "
                            :outlined="
                              !epdRequiredFields.birth_management_code
                            "
                            v-model="epdV2.birthManagementCode"
                            flat
                            placeholder="Enter Code"
                            maxlength="10"
                          ></v-text-field>
                        </v-col>
  
                        <!-- Birth Weight -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                            for="birthWeight"
                          >
                            {{ $t("Birth Weight") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.birthWeight") }}</span>
                            </v-tooltip>
                          </label>
                          <v-row class="d-flex">
                            <v-col cols="6">
                              <v-text-field
                                :class="{
                                  'required-field':
                                    epdRequiredFields.birth_weight,
                                }"
                                :solo="epdRequiredFields.birth_weight"
                                :outlined="!epdRequiredFields.birth_weight"
                                flat
                                @keypress="NumbersOnly"
                                :rules="formRules.birthWeight"
                                v-model="epdV2.birthWeight"
                                dense
                                type="number"
                                min="0"
                                placeholder="e.g. 123"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-select
                                append-icon=""
                                :class="{
                                  'required-field':
                                    epdRequiredFields.birth_weight,
                                }"
                                :solo="epdRequiredFields.birth_weight"
                                :outlined="!epdRequiredFields.birth_weight"
                                flat
                                dense
                                :items="weightUnits"
                                item-text="name"
                                item-value="value"
                                :value="animal.weightUnit"
                                disabled
                                placeholder="Select Unit"
                              ></v-select>
                            </v-col>
                          </v-row>
                        </v-col>
  
                        <!-- Conception Method -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                            for="conceptionMethod"
                            >{{ $t("animal.conceptionMethod") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.conceptionMethod") }}</span>
                            </v-tooltip>
                          </label>
                          <v-select
                            :items="conceptionMethod"
                            item-text="text"
                            item-value="text"
                            :class="{
                              'required-field':
                                epdRequiredFields.B_conception_method,
                            }"
                            :solo="epdRequiredFields.B_conception_method"
                            :outlined="!epdRequiredFields.B_conception_method"
                            flat
                            dense
                            v-model="animal.conceptionMethod"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-alert text outlined color="secondary2" class="note">
                        <span
                          class="black--text"
                          v-html="requiredFieldMessages['Birth Weight']"
                        ></span>
                      </v-alert>
                    </v-card-text>
  
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn outlined color="primary" @click="stepper = 1">
                        Back
                      </v-btn>
                      <v-btn color="primary" @click="stepper = 3" depressed>
                        Continue
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-stepper-content>
  
                <v-stepper-content step="3" class="no-border">
                  <v-card flat>
                    <v-toolbar color="transparent" flat class="black--text">
                      <v-toolbar-title class="font-weight-bold"
                        >Weaning Weight Information</v-toolbar-title
                      >
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <hr />
                    <v-card-text>
                      <v-row>
                        <!-- Yearling Management Code -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium text-wrap"
                          >
                            Management/Pasture Code
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.managementPastureCode") }}</span>
                            </v-tooltip>
                          </label>
                          <v-text-field
                            dense
                            :class="{
                              'required-field':
                                epdRequiredFields.management_pasture_code,
                            }"
                            :solo="epdRequiredFields.management_pasture_code"
                            :outlined="!epdRequiredFields.management_pasture_code"
                            flat
                            v-model="epdV2.pastureCode"
                            placeholder="Enter Code"
                            maxlength="10"
                          ></v-text-field>
                        </v-col>
  
                        <!-- Weaning Date -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                            for="dob"
                            >{{ $t("Date Weighing") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.weaningDate") }}</span>
                            </v-tooltip>
                          </label>
                          <v-menu
                            v-model="animalWeaningDatemenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                @click:append="animalWeaningDatemenu = true"
                                append-icon="mdi-calendar"
                                :class="{
                                  'required-field':
                                    epdRequiredFields.W_date_weighing,
                                }"
                                :solo="epdRequiredFields.W_date_weighing"
                                :outlined="!epdRequiredFields.W_date_weighing"
                                flat
                                dense
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                v-model="epdV2.weaningDate"
                                placeholder="Date Weighed"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="epdV2.weaningDate"
                              @input="animalWeaningDatemenu = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
  
                        <!-- Weaning Weight -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                            for="weaningWeight"
                            >{{ $t("Weaning Weight") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.weaningWeight") }}</span>
                            </v-tooltip>
                          </label>
                          <v-row class="d-flex">
                            <v-col cols="6">
                              <v-text-field
                                v-model="epdV2.weaningWeight"
                                @keypress="NumbersOnly"
                                :class="{
                                  'required-field':
                                    epdRequiredFields.weaning_weight,
                                }"
                                :solo="epdRequiredFields.weaning_weight"
                                :outlined="!epdRequiredFields.weaning_weight"
                                flat
                                dense
                                type="number"
                                min="0"
                                placeholder="e.g. 123"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-select
                                append-icon=""
                                :class="{
                                  'required-field':
                                    epdRequiredFields.weaning_weight,
                                }"
                                :solo="epdRequiredFields.weaning_weight"
                                :outlined="!epdRequiredFields.weaning_weight"
                                flat
                                dense
                                :items="weightUnits"
                                item-text="name"
                                item-value="value"
                                :value="animal.weightUnit"
                                disabled
                                placeholder="Select Unit"
                              >
                              </v-select>
                            </v-col>
                          </v-row>
                        </v-col>
  
                        <!-- Weaning Sex -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                            for="gender"
                          >
                            {{ $t("Weaning Sex") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.weaningSex") }}</span>
                            </v-tooltip>
                          </label>
                          <v-select
                            :items="genderOptions"
                            item-text="text"
                            item-value="value"
                            :class="{
                              'required-field': epdRequiredFields.weaning_sex,
                            }"
                            :solo="epdRequiredFields.weaning_sex"
                            :outlined="!epdRequiredFields.weaning_sex"
                            flat
                            dense
                            v-model="epdV2.weaningSex"
                            placeholder="Weaning Sex"
                          ></v-select>
                        </v-col>
  
                        <!-- Conception Method -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                            for="conceptionMethod"
                            >{{ $t("animal.conceptionMethod") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.conceptionMethod") }}</span>
                            </v-tooltip>
                          </label>
                          <v-select
                            :items="conceptionMethod"
                            item-text="text"
                            item-value="text"
                            :class="{
                              'required-field':
                                epdRequiredFields.W_conception_method,
                            }"
                            :solo="epdRequiredFields.W_conception_method"
                            :outlined="!epdRequiredFields.W_conception_method"
                            flat
                            dense
                            v-model="animal.conceptionMethod"
                            :placeholder="$t('animal.conceptionMethod')"
                          ></v-select>
                        </v-col>
  
                        <!-- Primary Breed -->
                        <v-col lg="6" md="6" sm="6" xs="6">
                          <v-row>
                            <v-col cols="6">
                              <label
                                class="subtitle-1 black--text font-weight-medium text-no-wrap"
                              >
                                {{ $t("Primary Breed") }}
                                <v-tooltip top color="black" max-width="350">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>{{ $t("epd.primaryBreed") }}</span>
                                </v-tooltip>
                              </label>
                              <v-autocomplete
                              placeholder="Select Breed"
                              flat
                              v-model="epdV2.primaryBreed"
                              :items="breeds"
                              :class="{
                                  'required-field':
                                    epdRequiredFields.W_primary_breed_composition,
                                }"
                                :solo="
                                  epdRequiredFields.W_primary_breed_composition
                                "
                                :outlined="
                                  !epdRequiredFields.W_primary_breed_composition
                                "
                              dense
                              item-text="name"
                              item-value="name"
                            >
                              <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                  <v-list-item-content v-text="data.item"></v-list-item-content>
                                </template>
                                <template v-else>
                                  <v-list-item-content>
                                    <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                  </v-list-item-content>
                                </template>
                              </template>
                            </v-autocomplete>
                            </v-col>
                            <v-col cols="6">
                              <label
                                class="subtitle-1 black--text font-weight-medium text-no-wrap"
                              >
                                {{ $t("Breed Composition") }}
                                <v-tooltip top color="black" max-width="350">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>{{ $t("epd.breedComposition") }}</span>
                                </v-tooltip>
                              </label>
                              <v-text-field
                                max="100"
                                v-model="breedComposition1"
                                @keypress="NumbersOnly"
                                :class="{
                                  'required-field':
                                    epdRequiredFields.W_primary_breed_composition,
                                }"
                                :solo="
                                  epdRequiredFields.W_primary_breed_composition
                                "
                                :outlined="
                                  !epdRequiredFields.W_primary_breed_composition
                                "
                                flat
                                dense
                                type="number"
                                min="0"
                                placeholder="e.g 80%"
                                :error-messages="wPBCerror"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>
  
                        <!-- Secondary Breed -->
                        <v-col lg="6" md="6" sm="6" xs="6">
                          <v-row class="d-flex">
                            <v-col cols="6">
                              <label
                                class="subtitle-1 black--text font-weight-medium"
                              >
                                {{ $t("Secondary Breed") }}
                                <v-tooltip top color="black" max-width="350">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>{{ $t("epd.secondaryBreed") }}</span>
                                </v-tooltip>
                              </label>
                              <v-autocomplete
                              placeholder="Select Breed"
                              flat
                              v-model="epdV2.secondaryBreed"
                              :items="breeds"
                              :class="{
                                  'required-field':
                                    epdRequiredFields.W_secondary_breed_composition,
                                }"
                                :solo="
                                  epdRequiredFields.W_secondary_breed_composition
                                "
                                :outlined="
                                  !epdRequiredFields.W_secondary_breed_composition
                                "
                              dense
                              item-text="name"
                              item-value="name"
                              :error-messages="wSBCerror"
                            >
                              <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                  <v-list-item-content v-text="data.item"></v-list-item-content>
                                </template>
                                <template v-else>
                                  <v-list-item-content>
                                    <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                  </v-list-item-content>
                                </template>
                              </template>
                            </v-autocomplete>
                            </v-col>
                            <v-col cols="6">
                              <label
                                class="subtitle-1 black--text font-weight-medium"
                              >
                                {{ $t("Breed Composition") }}
                                <v-tooltip top color="black" max-width="350">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>{{ $t("epd.breedComposition") }}</span>
                                </v-tooltip>
                              </label>
                              <v-text-field
                                v-model="breedCompositionSecondary1"
                                @keypress="NumbersOnly"
                                :class="{
                                  'required-field':
                                    epdRequiredFields.W_secondary_breed_composition,
                                }"
                                :solo="
                                  epdRequiredFields.W_secondary_breed_composition
                                "
                                :outlined="
                                  !epdRequiredFields.W_secondary_breed_composition
                                "
                                flat
                                dense
                                type="number"
                                min="0"
                                max="100"
                                placeholder="e.g 20%"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-alert text outlined color="secondary2" class="note">
                        <span
                          class="black--text"
                          v-html="requiredFieldMessages['Weaning Weight']"
                        ></span>
                      </v-alert>
                    </v-card-text>
  
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn outlined color="primary" @click="stepper = 2">
                        Back
                      </v-btn>
                      <v-btn color="primary" @click="stepper = 4" depressed>
                        Continue
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-stepper-content>
  
                <v-stepper-content step="4" class="no-border">
                  <v-card flat>
                    <v-toolbar color="transparent" flat class="black--text">
                      <v-toolbar-title class="font-weight-bold"
                        >Yearling Weight Information</v-toolbar-title
                      >
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <hr />
                    <v-card-text>
                      <v-row>
                        <!-- Management/Feeding Unit Code -->
                        <v-col lg="6" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 font-weight-medium text-no-wrap black--text"
                          >
                            Management/Feeding Unit Code
  
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.managementFeedUnitCode") }}</span>
                            </v-tooltip>
                          </label>
                          <v-text-field
                            dense
                            :class="{
                              'required-field':
                                epdRequiredFields.management_feeding_batch_code,
                            }"
                            :solo="
                              epdRequiredFields.management_feeding_batch_code
                            "
                            :outlined="
                              !epdRequiredFields.management_feeding_batch_code
                            "
                            flat
                            v-model="epdV2.yearlingManagementCode"
                            placeholder="Enter Code"
                            maxlength="10"
                          ></v-text-field>
                        </v-col>
  
                        <!-- Yearling Date -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 font-weight-medium black--text"
                            for="dob"
                            >{{ $t("Date Weighing") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("Date Weighing") }}</span>
                            </v-tooltip>
                          </label>
                          <v-menu
                            v-model="yearlingDatemenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                @click:append="yearlingDatemenu = true"
                                append-icon="mdi-calendar"
                                dense
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                v-model="epdV2.yearlingDate"
                                placeholder="Date Weighing"
                                flat
                                :class="{
                                  'required-field':
                                    epdRequiredFields.Y_date_weighing,
                                }"
                                :solo="epdRequiredFields.Y_date_weighing"
                                :outlined="!epdRequiredFields.Y_date_weighing"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="epdV2.yearlingDate"
                              @input="yearlingDatemenu = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
  
                        <!-- Yearling Sex -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 font-weight-medium black--text"
                            for="gender"
                          >
                            {{ $t("Yearling Sex") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.yearlingSex") }}</span>
                            </v-tooltip>
                          </label>
                          <v-select
                            :items="genderOptions"
                            item-text="text"
                            item-value="value"
                            :class="{
                              'required-field': epdRequiredFields.yearling_sex,
                            }"
                            :solo="epdRequiredFields.yearling_sex"
                            :outlined="!epdRequiredFields.yearling_sex"
                            flat
                            dense
                            v-model="epdV2.yearlingSex"
                            placeholder="Yearling sex"
                          ></v-select>
                        </v-col>
  
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 font-weight-medium black--text"
                            for="conceptionMethod"
                          >
                            {{ $t("Yearling Weight") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.yearlingWeight") }}</span>
                            </v-tooltip>
                          </label>
                          <v-row class="d-flex">
                            <v-col cols="6">
                              <v-text-field
                                v-model="epdV2.yearlingWeight"
                                @keypress="NumbersOnly"
                                :class="{
                                  'required-field':
                                    epdRequiredFields.yearling_weight,
                                }"
                                :solo="epdRequiredFields.yearling_weight"
                                :outlined="!epdRequiredFields.yearling_weight"
                                flat
                                dense
                                type="number"
                                min="0"
                                placeholder="e.g. 123"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-select
                                append-icon=""
                                :class="{
                                  'required-field':
                                    epdRequiredFields.yearling_weight,
                                }"
                                :solo="epdRequiredFields.yearling_weight"
                                :outlined="!epdRequiredFields.yearling_weight"
                                flat
                                dense
                                :items="weightUnits"
                                item-text="name"
                                item-value="value"
                                :value="animal.weightUnit"
                                disabled
                                placeholder="Select Unit"
                              >
                              </v-select>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-alert text outlined color="secondary2">
                        <span
                          class="black--text"
                          v-html="requiredFieldMessages['Yearling Weight']"
                        ></span>
                      </v-alert>
                    </v-card-text>
  
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn outlined @click="stepper = 3" color="primary"
                        >Back</v-btn
                      >
                      <v-btn color="primary" @click="stepper = 5" depressed
                        >Continue</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-stepper-content>
  
                <v-stepper-content step="5" class="no-border">
                  <v-card flat>
                    <v-toolbar color="transparent" flat class="black--text">
                      <v-toolbar-title class="font-weight-bold"
                        >Carcass Weight Information</v-toolbar-title
                      >
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <hr />
                    <v-card-text>
                      <p
                        v-if="epdV2.harvestDate == ''"
                        class="font-weight-medium red--text"
                      >
                        Please select 'Harvest Date' first to enter info for Rib
                        Eye Area, Fat Thickness and Marbling
                      </p>
                      <v-row>
                        <!-- Management/Pen/Feeding Unit Code  -->
                        <v-col lg="6" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text text-wrap font-weight-medium"
                          >
                            Management/Pen/Feeding Unit Code
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.managementFeedUnitCode") }}</span>
                            </v-tooltip>
                          </label>
                          <v-text-field
                            dense
                            v-model="epdV2.feedingCode"
                            placeholder="Enter Code"
                            flat
                            :class="{
                              'required-field':
                                epdRequiredFields.management_pen_feeding_batch,
                            }"
                            :solo="epdRequiredFields.management_pen_feeding_batch"
                            :outlined="!epdRequiredFields.management_pen_feeding_batch"
                            maxlength="10"
                          ></v-text-field>
                        </v-col>
  
                        <!-- Days On Feed -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 text-wrap black--text font-weight-medium"
                          >
                            Days On Feed
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.daysOnFeed") }}</span>
                            </v-tooltip>
                          </label>
                          <v-text-field
                            dense
                            :class="{
                              'required-field': epdRequiredFields.days_on_feed,
                            }"
                            :solo="epdRequiredFields.days_on_feed"
                            :outlined="!epdRequiredFields.days_on_feed"
                            v-model="epdV2.daysOnFeed"
                            @keypress="NumbersOnly"
                            type="number"
                            :disabled="epdV2.harvestDate == ''"
                            flat
                            placeholder="e.g 15"
                          ></v-text-field>
                        </v-col>
  
                        <!-- Harvest Date -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                            for="dob"
                            >{{ $t("Harvest Date") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.harvestDate") }}</span>
                            </v-tooltip>
                          </label>
                          <v-menu
                            v-model="harvestDateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                @click:append="harvestDateMenu = true"
                                append-icon="mdi-calendar"
                                :class="{
                                  'required-field':
                                    epdRequiredFields.harvest_date,
                                }"
                                :solo="epdRequiredFields.harvest_date"
                                :outlined="!epdRequiredFields.harvest_date"
                                dense
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                v-model="epdV2.harvestDate"
                                :error-messages="errors.harvestDate"
                                flat
                                placeholder="Harvest Date"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="epdV2.harvestDate"
                              @input="harvestDateMenu = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
  
                        <!-- Grading Date -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                            for="dob"
                            >{{ $t("Grading Date") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.gradingDate") }}</span>
                            </v-tooltip>
                          </label>
                          <v-menu
                            v-model="gradingDateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                @click:append="gradingDateMenu = true"
                                append-icon="mdi-calendar"
                                :class="{
                                  'required-field':
                                    epdRequiredFields.grading_date,
                                }"
                                :solo="epdRequiredFields.grading_date"
                                :outlined="!epdRequiredFields.grading_date"
                                dense
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                v-model="epdV2.gradingDate"
                                flat
                                placeholder="Grading Date"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="epdV2.gradingDate"
                              @input="gradingDateMenu = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
  
                        <!-- Carcass Sex -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                          >
                            Carcass Sex
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.carcassSex") }}</span>
                            </v-tooltip>
                          </label>
                          <v-select
                            :items="genders"
                            item-text="text"
                            item-value="value"
                            :class="{
                              'required-field': epdRequiredFields.carcass_sex,
                            }"
                            :solo="epdRequiredFields.carcass_sex"
                            :outlined="!epdRequiredFields.carcass_sex"
                            dense
                            v-model="epdV2.carcassSex"
                            flat
                            placeholder="Carcass Sex"
                          ></v-select>
                        </v-col>
  
                        <!-- Date On Feed -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                            for="dob"
                            >{{ $t("Date On Feed") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.dateonFeed") }}</span>
                            </v-tooltip>
                          </label>
                          <v-menu
                            v-model="dateOnFeedMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                @click:append="dateOnFeedMenu = true"
                                append-icon="mdi-calendar"
                                :class="{
                                  'required-field':
                                    epdRequiredFields.date_on_feed,
                                }"
                                :solo="epdRequiredFields.date_on_feed"
                                :outlined="!epdRequiredFields.date_on_feed"
                                dense
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                v-model="epdV2.dateOnFeed"
                                flat
                                placeholder="Date On Feed"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="epdV2.dateOnFeed"
                              @input="dateOnFeedMenu = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
  
                        <!-- Breed of Dam -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                          >
                            Breed of Dam
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("Breed of Dam") }}</span>
                            </v-tooltip>
                          </label>
                          <v-select
                            :class="{
                              'required-field': epdRequiredFields.breed_of_dam,
                            }"
                            :solo="epdRequiredFields.breed_of_dam"
                            :outlined="!epdRequiredFields.breed_of_dam"
                            flat
                            dense
                            :items="breeds"
                            v-model="epdV2.breedOfDam"
                            placeholder="Select Breed"
                          ></v-select>
                        </v-col>
  
                        <!-- Carcass Weight -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                            for="CarcassWeight"
                            >{{ $t("Carcass Weight") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.carcassWeight") }}</span>
                            </v-tooltip>
                          </label>
                          <v-row class="d-flex" no-gutters>
                            <v-col cols="8">
                              <v-text-field
                                v-model="epdV2.carcassWeight"
                                :disabled="epdV2.harvestDate == ''"
                                @keypress="NumbersOnly"
                                :class="{
                                  'required-field':
                                    epdRequiredFields.carcass_weight,
                                }"
                                :solo="epdRequiredFields.carcass_weight"
                                :outlined="!epdRequiredFields.carcass_weight"
                                dense
                                min="0"
                                flat
                                placeholder="e.g. 123"
                                maxlength="12"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="4" class="pl-1">
                              <v-select
                                append-icon=""
                                :class="{
                                  'required-field':
                                    epdRequiredFields.carcass_weight,
                                }"
                                :solo="epdRequiredFields.carcass_weight"
                                :outlined="!epdRequiredFields.carcass_weight"
                                dense
                                :items="weightUnits"
                                item-text="name"
                                item-value="value"
                                :value="animal.weightUnit"
                                disabled
                                flat
                                placeholder="Select Unit"
                              >
                              </v-select>
                            </v-col>
                          </v-row>
                        </v-col>
  
                        <!-- Marbling -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                          >
                            Marbling
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.marbling") }}</span>
                            </v-tooltip>
                          </label>
                          <!-- <v-row class="d-flex">
                            <v-col cols="6"> -->
                              <v-text-field
                                dense
                                :class="{
                                  'required-field': epdRequiredFields.marbling,
                                }"
                                :solo="epdRequiredFields.marbling"
                                :outlined="!epdRequiredFields.marbling"
                                v-model="epdV2.marbling"
                                @keypress="NumbersOnly"
                                :disabled="epdV2.harvestDate == ''"
                                flat
                                placeholder="e.g. 123"
                                maxlength="12"
                              ></v-text-field>
                            <!-- </v-col> -->
                            <!-- <v-col cols="6">
                              <v-select
                                append-icon=""
                                :class="{
                                  'required-field': epdRequiredFields.marbling,
                                }"
                                :solo="epdRequiredFields.marbling"
                                :outlined="!epdRequiredFields.marbling"
                                dense
                                :items="weightUnits"
                                item-text="name"
                                item-value="value"
                                v-model="epdV2.marblingUnit"
                                flat
                                placeholder="Select Unit"
                              >
                              </v-select>
                            </v-col>
                          </v-row> -->
                        </v-col>
  
                        <!-- Fat Thickness -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                          >
                            Fat Thickness
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.fatThickness") }}</span>
                            </v-tooltip>
                          </label>
                          <v-row class="d-flex" no-gutters>
                            <v-col cols="8">
                              <v-text-field
                                dense
                                :class="{
                                  'required-field':
                                    epdRequiredFields.fat_thickness,
                                }"
                                :solo="epdRequiredFields.fat_thickness"
                                :outlined="!epdRequiredFields.fat_thickness"
                                flat
                                v-model="epdV2.fatThickness"
                                @keypress="NumbersOnly"
                                :disabled="epdV2.harvestDate == ''"
                                placeholder="e.g. 1234"
                                maxlength="12"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="4" class="pl-1">
                              <v-select
                                append-icon=""
                                :class="{
                                  'required-field':
                                    epdRequiredFields.fat_thickness,
                                }"
                                :solo="epdRequiredFields.fat_thickness"
                                :outlined="!epdRequiredFields.fat_thickness"
                                flat
                                dense
                                :items="fatUnit"
                                item-text="name"
                                item-value="value"
                                v-model="epdV2.fatThicknessUnit"
                                placeholder="Select Unit"
                              >
                              </v-select>
                            </v-col>
                          </v-row>
                        </v-col>
  
                        <!-- Rib Eye Area -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                          >
                            Rib Eye Area
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.ribeyeArea") }}</span>
                            </v-tooltip>
                          </label>
                          <v-row class="d-flex" no-gutters>
                            <v-col cols="8">
                              <v-text-field
                                dense
                                :class="{
                                  'required-field':
                                    epdRequiredFields.rib_eye_area,
                                }"
                                :solo="epdRequiredFields.rib_eye_area"
                                :outlined="!epdRequiredFields.rib_eye_area"
                                flat
                                v-model="epdV2.ribEyeArea"
                                @keypress="NumbersOnly"
                                :disabled="epdV2.harvestDate == ''"
                                :rules="ribEyeAreaRule"
                                placeholder="e.g. 123"
                                maxlength="12"
                                min="0"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="4" class="pl-1">
                              <v-select
                                append-icon=""
                                :class="{
                                  'required-field':
                                    epdRequiredFields.rib_eye_area,
                                }"
                                :solo="epdRequiredFields.rib_eye_area"
                                :outlined="!epdRequiredFields.rib_eye_area"
                                flat
                                dense
                                :items="ribUnit"
                                item-text="name"
                                item-value="value"
                                v-model="epdV2.ribEyeAreaUnit"
                                placeholder="Select Unit"
                              >
                              </v-select>
                            </v-col>
                          </v-row>
                        </v-col>
  
                        <!-- KPH Fat -->
                        <v-col lg="4" md="6" sm="6" xs="6">
                          <label
                            class="subtitle-1 black--text font-weight-medium"
                            for="kph"
                            >{{ $t("KPH") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("epd.KPH") }}</span>
                            </v-tooltip>
                          </label>
                          <v-row class="d-flex" no-gutters>
                            <v-col cols="8">
                              <v-text-field
                                v-model="epdV2.kphFat"
                                @keypress="NumbersOnly"
                                :class="{
                                  'required-field': epdRequiredFields.kph,
                                }"
                                :solo="epdRequiredFields.kph"
                                :outlined="!epdRequiredFields.kph"
                                flat
                                dense
                                maxlength="12"
                                min="0"
                                placeholder="e.g. 123"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="4" class="pl-1">
                              <v-select
                                append-icon=""
                                :class="{
                                  'required-field': epdRequiredFields.kph,
                                }"
                                :solo="epdRequiredFields.kph"
                                :outlined="!epdRequiredFields.kph"
                                dense
                                :items="['%']"
                                v-model="epdV2.kphFatUnit"
                                disabled
                                flat
                                placeholder="Select Unit"
                              >
                              </v-select>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-alert text outlined color="secondary2">
                        <span
                          class="black--text"
                          v-html="requiredFieldMessages['Carcass Weight']"
                        ></span>
                      </v-alert>
                    </v-card-text>
  
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn outlined color="primary" @click="stepper = 4">
                        Back
                      </v-btn>
                      <v-btn color="primary" depressed @click="submitForm">
                        {{ action == "create" ? "Submit" : "Update" }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-stepper-content>
              </v-stepper>
            </v-card>
          </v-form>
        </v-col>
      </v-row>
  
      <!-- Old component -->
      <v-dialog v-model="dataSubType" persistent max-width="400">
        <v-card class="pb-5">
          <v-toolbar flat class="white--text" color="secondary">
            <v-toolbar-title>Submitting Data...</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="dataSubType = false">
              <v-icon class="white--text">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-5 text-center">
            <v-img height="130" contain src="/img/shield.png"></v-img>
            <p class="mt-5">{{ errorMsg }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" outlined @click="dataSubType = false">
              Cancel
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="mainDataWarning" persistent max-width="400">
        <v-card class="pb-5">
          <v-toolbar flat class="white--text" color="secondary">
            <v-toolbar-title></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="mainDataWarning = false">
              <v-icon class="white--text">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-5">
            <h4 class="black--text">Are you sure?</h4>
            <p class="mt-5">This will update your main animal info.</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              outlined
              @click="mainDataWarning = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              @click="
                () => {
                  mainDataWarning = false;
                  editMainData = true;
                }
              "
            >
              Confirm
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Old component end -->
    </div>
  </template>
  
  <script>
  import EPDService from "@/_services/EPDService";
  import loadingMixin from "@/mixins/LoadingMixin";
  import AnimalService from "@/_services/AnimalService";
  import EPDsettingsService from "@/_services/EPDsettingsService";
  import AnimalDropdown from "@/components/AnimalDropdown.vue";
  import {
      breeds
  } from "@/models/units.js"
  
  export default {
    components: {
      AnimalDropdown,
    },
    mounted() {
      this.getRequiredFields();
      if (this.action == "update") {
        this.assignValues();
      }
      if (this.action == "create") {
        this.epdV2.unit = this.animal.weightUnit;
        this.epdV2.birthWeight = this.animal.birthWeight;
      }
  
      this.breedComposition1 = this.epdV2.breedCompositionPrimary;
      this.breedCompositionSecondary1 = this.epdV2.breedCompositionSecondary;
      if (this.animal.dams) {
        this.epdV2.damId = this.animal.dams.id;
      }
      if (this.animal.sires) this.epdV2.sireId = this.animal.sires.id;
      // this.editMainDataFun
      // this.pythonUrl = process.env.VUE_APP_PYTHON_BACKEND
      // console.log('py', this.pythonUrl, process.env.VUE_APP_PYTHON_BACKEND)
    },
  
    watch: {
      epdV2: {
        handler() {
          if (!this.formSubmited) this.$emit("form-updated", true);
        },
        deep: true,
      },
      animal: {
        handler() {
          if (this.action == "update") {
            this.assignValues();
          }
        },
      },
      "epdV2.harvestDate": {
        handler() {
          this.calculateDaysOnFeed();
        },
        deep: true,
      },
      "epdV2.daysOnFeed": {
        handler() {
          this.calculateDaysOnFeed();
        },
        deep: true,
      },
      "epdV2.dateOnFeed": {
        handler() {
          this.calculateDaysOnFeed();
        },
        deep: true,
      },
      breedComposition1: function () {
        if( this.breedComposition1 > 100){
          this.breedComposition1 = 100
        }else if( this.breedComposition1 < 0){
          this.breedComposition1 = 0
        }
        if((Number(this.breedComposition1) + Number(this.breedCompositionSecondary1))>100){
          this.wPBCerror = 'Breed Composition total can\'t be more then 100'
          this.wSBCerror = 'Breed Composition total can\'t be more then 100'
        }else {
          this.wPBCerror = ''
          this.wSBCerror = ''
        }
        // fdddd
        // if (val < 101) {
        //   this.breedCompositionSecondary1 = 100 - val;
        // } else {
        //   this.breedComposition1 = 0;
        // }
      },
      breedCompositionSecondary1: function () {
        if( this.breedCompositionSecondary1 > 100){
          this.breedCompositionSecondary1 = 100
        }else if( this.breedCompositionSecondary1 < 0){
          this.breedCompositionSecondary1 = 0
        }
        if((Number(this.breedComposition1) + Number(this.breedCompositionSecondary1))>100){
          this.wPBCerror = 'Breed Composition total can\'t be more then 100'
          this.wSBCerror = 'Breed Composition total can\'t be more then 100'
        }else {
          this.wPBCerror = ''
          this.wSBCerror = ''
        }
        // if (val < 101) {
        //   this.breedComposition1 = 100 - val;
        // } else {
        //   this.breedCompositionSecondary1 = 0;
        // }
      },
    },
    computed: {
      currentUser() {
        return this.$store.getters.getUser;
      },
      birthYear() {
        return this.animal.dob == ""
          ? ""
          : new Date(this.animal.dob).getFullYear().toString();
      },
      animalImg() {
        return this.animal?.img?.url || "/img/no_img.png";
      },
      today() {
          return new Date().toISOString().split('T')[0];
      },
      ribEyeAreaRule() {
        return [
          v => /^-?\d*(\.\d+)?$/.test(v) || 'Enter a valid number',
          v => v >= 0 || "value can't be less then 0",
          v => (v && parseInt(v)>0) || 'Negative numbers are not allowed',
        ];
      },
    },
    data() {
      return {
        breeds,
        formSubmited: false,
        stepper: 1,
        formSteps: [
          {
            step: 1,
            name: "Basic Information",
          },
          {
            step: 2,
            name: "Birth Weight Information",
          },
          {
            step: 3,
            name: "Weaning Weight Information",
          },
          {
            step: 4,
            name: "Yearling Weight Information",
          },
          {
            step: 5,
            name: "Carcass Weight Information",
          },
        ],
        requiredFieldMessages: {
          "Birth Weight": "",
          "Weaning Weight": "",
          "Yearling Weight": "",
          "Carcass Weight": "",
        },
        pythonUrl: "",
        ele: "",
        valid: true,
        formRules: {
          damAge: [
            // v => !!v || 'Dam age is required.',
            (v) => !v || v > 0 || "Can't be less then 1",
          ],
          birthWeight: [
            // v => !!v || 'Birth weight is required',
            (v) => !v || v > 0 || "Can't be less then 1",
          ],
          // yearlingHeight: [
          //     v => (v == "" || (v > 0 && v <= 84) || "Hight should be between 1-84"),
          // ]
        },
        mainDataWarning: false,
        editMainData: true,
        dataSubType: false,
        errorMsg: "",
        breedComposition1: "",
        breedCompositionSecondary1: "",
        birthSeasons: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
        epdV2: {
          animalRegistrationId: null,
          internationalId: "", // String
          location: "", // String
          // animalName: '', // String
          // gender: '', // String
          additionalIdMethod: "", // String
          conceptionMethod: '', // String
          damId: "", // String
          sireId: "", // String
          // dateOfBirth: '', // String
          breederHerdCode: "", // String
          birthManagementCode: "", // String
          // birthYear: null, // Number
          seasonOfBirth: "", // String ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December', 'january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],
          birthWeight: null, // Number
          // birthWeightUnit: 'lbs', // String
          birthSex: "", // String
          primaryBreed: "", // String
          breedCompositionPrimary: "", // String
          secondaryBreed: "", // String
          breedCompositionSecondary: "", // String
          birthWeightCgId: "", // String
          pastureCode: "", // String
          weaningDate: "", // String
          weaningSex: "", // String
          weaningWeight: null, // Number
          // weaningWeightUnit: '', // String
          weaningWeightCgId: "", // String
          yearlingManagementCode: "", // String
          yearlingDate: "", // String
          yearlingWeight: null, // Number
          yearlingWeightUnit: "", // String
          yearlingSex: "", // String
          yearlingWeightCgId: "", // String
          feedingCode: "", // String
          daysOnFeed: null, // Number
          dateOnFeed: "", // String
          gradingDate: "", // String
          harvestDate: "", // String
          breedOfDam: "", // String
          carcassSex: "", // String
          carcassWeight: null, // Number
          // carcassWeightUnit: null, // Number
          fatThickness: null, // Number
          fatThicknessUnit: null, // Number
          ribEyeArea: null, // Number
          ribEyeAreaUnit: null, // Number
          marbling: null, // Number
          marblingUnit: null, // Number
          kphFat: null, // Number
          kphFatUnit: "%", // Number
          // managementPastureCode: "",
        },
        animalEPD: {},
        animalDOBmenu: false,
        harvestDateMenu: false,
        gradingDateMenu: false,
        dateOnFeedMenu: false,
        birthYearMenu: false,
        animalWeaningDatemenu: false,
        yearlingDatemenu: false,
        panel: 0,
        genders: [
          {
            text: this.$t("animal.male"),
            value: "male",
          },
          {
            text: this.$t("animal.female"),
            value: "female",
          },
        ],
        genderOptions: [
          {
            text: this.$t("animal.male"),
            value: "male",
          },
          {
            text: this.$t("animal.female"),
            value: "female",
          },
          {
            text: this.$t("animal.castrated"),
            value:"castrated"
          }
        ],
        animalStatuses: ["Healthy", "Sick", "Animal Show"],
        conceptionMethod: [
          {
            text: this.$t("animal.naturalMating"),
            value: "1",
          },
          {
            text: this.$t("animal.artificialInsemination"),
            value: "2",
          },
          {
            text: this.$t("animal.embryoTransfer"),
            value: "3",
          },
        ],
        weightUnits: [
          {
            name: "Kg",
            value: "KG",
          },
          {
            name: "Lbs",
            value: "LBS",
          },
        ],
        fatUnit:[
          {
            name:"cm",
            value:"cm"
          },
          {
            name:"inch",
            value:"inch"
          }
        ],
        ribUnit:[
          {
            name:"mm",
            value:"mm"
          },
          {
            name:"inch",
            value:"inch"
          }
        ],
        switch1: false,
        errors: {
          registrationNumber: "",
          birthWeight: "",
          sirePubId: "",
          damPubId: "",
          conceptionMethod: "",
          gender: "",
          dob: "",
          name: "",
          harvestDate: "",
          status: "",
        },
        epdRequiredFields: {},
      };
    },
    props: {
      animal: {
        required: true,
      },
      action: {
        type: String,
        default: "create", // accepted values : create, update
      },
    },
    methods: {
      async getRequiredFields() {
        try {
          const { data } = await EPDsettingsService.getEPDsettings("all");
          data.data.forEach((mod) => {
            var reqF = [];
            mod.requiredFields.forEach((field) => {
              if (field.status) {
                reqF.push(field.name);
              }
              if(field.id == 'conception_method' || field.id == 'primary_breed_composition' || field.id == 'secondary_breed_composition' || field.id == 'date_weighing') {
                console.log(field.id)
                this.epdRequiredFields[mod.traitType[0]+'_'+field.id] = field.status;
              }else
                this.epdRequiredFields[field.id] = field.status;
            });
            console.log('ccc', this.epdRequiredFields)
            if (reqF.length) {
              this.requiredFieldMessages[
                mod.traitType
              ] = `<b>Note:</b>Minimum required field for ${
                mod.traitType
              } EPDs <b> ${[...reqF].join(", ")} </b>`;
              reqF = [];
            }
          });
        } catch (e) {
          console.log("required fields error", e);
        }
      },
      closeWarningMessage(stay) {
        this.dataLossWarning = false;
        if (!stay) {
          this.formChanged = false;
          this.$router.push(this.promptToRoute);
        }
      },
      NumbersOnly(evt) {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46
        ) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      submitForm() {
        if (!this.$refs.form.validate()) return;
        this.epdV2.animalRegistrationId = this.animal.id;
        // this.epdV2.ageOfDam = Number(this.epdV2.ageOfDam)
        this.epdV2.birthWeight = Number(this.epdV2.birthWeight) || null;
        this.epdV2.weaningWeight = Number(this.epdV2.weaningWeight) || null;
        this.epdV2.yearlingWeight = Number(this.epdV2.yearlingWeight) || null;
        // this.epdV2.yearlingHeight = Number(this.epdV2.yearlingHeight)
        this.epdV2.kphFat = Number(this.epdV2.kphFat) || null;
        this.epdV2.fatThickness = Number(this.epdV2.fatThickness) || null;
        this.epdV2.ribEyeArea = Number(this.epdV2.ribEyeArea) || null;
        this.epdV2.marbling = Number(this.epdV2.marbling) || null;
        // this.epdV2.accuracyWeight_for_field = this.epdV2.accuracyWeight_for_field == null ? null : Number(this.epdV2.accuracyWeight_for_field)
        this.epdV2.carcassWeight = Number(this.epdV2.carcassWeight) || null;
        this.epdV2.breedCompositionPrimary =
          String(this.breedComposition1) || null;
        this.epdV2.breedCompositionSecondary =
          String(this.breedCompositionSecondary1) || null;
        this.epdV2.userId=this.currentUser.id;
        for (const [key, value] of Object.entries(this.epdV2)) {
          if (value == "" || value == null) {
            delete this.epdV2[key];
          }
        }
  
        this.$emit("form-updated", false);
        // if (this.action == "create") this.createEPDrecord();
        if (this.action == "create") this.createEPDrecordNew();
        else if (this.action == "update") this.updateEPD();
      },
      editMainDataFun() {
        // if(this.editMainData) this.editMainData= false;
        // else this.mainDataWarning = true;
      },
      async updateEPD() {
        this.formSubmited = true;
        await this.updateAnimalNew()
        this.startLoading();
        EPDService.updateEPDrecord(this.epdV2)
          .then((res) => {
            if (!res.success) throw res.message;
            // if (this.editMainData) {
              this.stopLoading();
              // this.updateAnimal();
            // } else {
              this.$emit("form-updated", false);
              this.$notify({
                title: "Record update successfully.",
                text: res.message,
                type: "success",
              });
              
              // this.stopLoading();
              // this.$router.push({
              //   name: "SingleAnimalEpd",
              //   params: {
              //     geneticid: this.animal.animalNumber,
              //   },
              // });
            // }
          })
          .catch((err) => {
            this.formSubmited = false;
            if (typeof err === "string" || err instanceof String) {
              this.errorMsg = err;
            } else {
              this.errorMsg =
                err?.data?.message ||
                "Something went wrong! Please try after sometime.";
            }
            this.dataSubType = true;
            this.stopLoading();
          });
      },
      updateAnimal() {
        this.startLoading();
        AnimalService.updateAnimal(this.animal)
          .then(() => {
            this.stopLoading();
            this.$router.push({
              name: "SingleAnimalEpd",
              params: {
                geneticid: this.animal.animalNumber,
              },
            });
          })
          .catch(() => {
            this.stopLoading();
            this.$router.push({
              name: "SingleAnimalEpd",
              params: {
                geneticid: this.animal.animalNumber,
              },
            });
          });
      },
  
      async updateAnimalNew() {
        this.startLoading();
        return AnimalService.updateAnimal(this.animal)
          .then(() => {
            this.stopLoading();
            return Promise.resolve(true)
          })
          .catch(() => {
            this.stopLoading();
            return Promise.reject(false)
          });
      },
  
      async calculateDaysOnFeed() {
        if (this.epdV2.harvestDate != "" && this.epdV2.dateOnFeed != "") {
          const date1 = new Date(this.epdV2.dateOnFeed);
          const date2 = new Date(this.epdV2.harvestDate);
          if (this.epdV2.harvestDate < this.epdV2.dateOnFeed) {
            this.errors.harvestDate = "Can't less then Date On Feed";
            this.epdV2.daysOnFeed = "";
            return;
          } else this.errors.harvestDate = "";
  
          const diffTime = await Math.abs(date2 - date1);
          // const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          this.epdV2.daysOnFeed = await Math.ceil(
            diffTime / (1000 * 60 * 60 * 24)
          );
        }
      },
      createEPDrecord() {
        this.startLoading();
        this.formSubmited = true;
        EPDService.createEPDrecord(this.epdV2)
          .then((res) => {
            if (!res.success) throw res.message;
            this.stopLoading();
            if (this.editMainData) {
              this.updateAnimal();
            } else {
              this.$emit("form-updated", false);
              this.$notify({
                title: "Record created successfully.",
                text: res.message,
                type: "success",
              });
              this.$router.push({
                name: "SingleAnimalEpd",
                params: {
                  geneticid: this.animal.animalNumber,
                },
              });
            }
          })
          .catch((err) => {
            this.stopLoading();
            this.formSubmited = false;
            if (typeof err === "string" || err instanceof String) {
              this.errorMsg = err;
            } else {
              this.errorMsg =
                err?.data?.message ||
                "Something went wrong! Please try after sometime.";
            }
            this.dataSubType = true;
          });
      },
  
      async createEPDrecordNew() {
        this.formSubmited = true;
        try {
          await this.updateAnimalNew()
          EPDService.createEPDrecord(this.epdV2)
          .then((res) => {
            if (!res.success) throw res.message;
            this.stopLoading();
            this.$emit("form-updated", false);
            this.$notify({
              title: "Record created successfully.",
              text: res.message,
              type: "success",
            });
  
            this.$router.push({
              name: "SingleAnimalEpd",
              params: {
                geneticid: this.animal.animalNumber,
              },
            });
            this.$router.push({ name: "Genetics" });
          })
          .catch((err) => {
            this.stopLoading();
            this.formSubmited = false;
            if (typeof err === "string" || err instanceof String) {
              this.errorMsg = err;
            } else {
              this.errorMsg =
                err?.data?.message ||
                "Something went wrong! Please try after sometime.";
            }
            this.dataSubType = true;
          });
        }catch(e) {
          console.log('Animal Update: something went wrong', e)
        }
      }, 
  
      assignValues() {
        if (this.animal?.AnimalEpd) {
          this.animalEPD = {
            ...this.animal.AnimalEpd,
          };
          const epdDD = {
            ...this.animal.AnimalEpd,
          };
          (this.epdV2.animalRegistrationId = this.animal.id),
            (this.epdV2.location = epdDD.location
              ? epdDD.location
              : this.epdV2.location);
          // this.epdV2.ageOfDam = epdDD.age_of_dam ? epdDD.age_of_dam : this.epdV2.ageOfDam
          this.epdV2.birthWeight = epdDD.birth_weight
            ? epdDD.birth_weight
            : this.epdV2.birthWeight;
          this.epdV2.weaningDate = epdDD.weaning_date
            ? epdDD.weaning_date
            : this.epdV2.weaningDate;
          this.epdV2.weaningWeight = epdDD.weaning_weight
            ? epdDD.weaning_weight
            : this.epdV2.weaningWeight;
          this.epdV2.yearlingDate = epdDD.yearling_date
            ? epdDD.yearling_date
            : this.epdV2.yearlingDate;
          this.epdV2.yearlingWeight = epdDD.yearling_weight
            ? epdDD.yearling_weight
            : this.epdV2.yearlingWeight;
          // this.epdV2.yearlingHeight = epdDD.yearling_height ? epdDD.yearling_height : this.epdV2.yearlingHeight
          this.epdV2.internationalId = epdDD.international_id
            ? epdDD.international_id
            : this.epdV2.internationalId;
          this.epdV2.pastureCode = epdDD.pasture_code ? epdDD.pasture_code : this.epdV2.pastureCode
          this.epdV2.feedingCode = epdDD.feeding_code
            ? epdDD.feeding_code
            : this.epdV2.feedingCode;
          // this.epdV2.managementCode = epdDD.management_code ? epdDD.management_code : this.epdV2.managementCode
          this.epdV2.breedCompositionPrimary = epdDD.breed_composition
            ? epdDD.breed_composition
            : this.epdV2.breedCompositionPrimary;
          this.epdV2.breedCompositionSecondary = epdDD.breed_composition_secondary
            ? epdDD.breed_composition_secondary
            : this.epdV2.breedCompositionSecondary;
          this.epdV2.seasonOfBirth = epdDD.season
            ? epdDD.season
            : this.epdV2.seasonOfBirth;
          // this.epdV2.creep = epdDD.creep ? epdDD.creep : this.epdV2.creep
          // this.epdV2.weaningWeightContGrp = epdDD.weaning_contemporary ? epdDD.weaning_contemporary : this.epdV2.weaningWeightContGrp
          // this.epdV2.yearlingWeightContGrp = epdDD.yearling_contemporary ? epdDD.yearling_contemporary : this.epdV2.yearlingWeightContGrp
          // this.epdV2.accuracyWeight_for_field = epdDD.accuracyWeight_for_field ? epdDD.accuracyWeight_for_field : this.epdV2.accuracyWeight_for_field
          // this.epdV2.unit = this.animal.weightUnit;
          this.breedComposition1 = this.epdV2.breedCompositionPrimary;
          this.breedCompositionSecondary1 = this.epdV2.breedCompositionSecondary;
          this.epdV2.daysOnFeed = epdDD.daysOnFeed
            ? epdDD.daysOnFeed
            : this.epdV2.daysOnFeed;
          this.epdV2.harvestDate = epdDD.harvestDate
            ? epdDD.harvestDate
            : this.epdV2.harvestDate;
          this.epdV2.gradingDate = epdDD.gradingDate
            ? epdDD.gradingDate
            : this.epdV2.gradingDate;
          this.epdV2.dateOnFeed = epdDD.dateOnFeed
            ? epdDD.dateOnFeed
            : this.epdV2.dateOnFeed;
          this.epdV2.breedOfDam = epdDD.breedOfDam
            ? epdDD.breedOfDam
            : this.epdV2.breedOfDam;
          this.epdV2.ribEyeArea = epdDD.ribEyeArea
            ? epdDD.ribEyeArea
            : this.epdV2.ribEyeArea;
          // this.epdV2.ribEyeArea_contemporary = epdDD.ribEyeArea_contemporary ? epdDD.ribEyeArea_contemporary : this.epdV2.ribEyeArea_contemporary
          this.epdV2.fatThickness = epdDD.fatThickness
            ? epdDD.fatThickness
            : this.epdV2.fatThickness;
          // this.epdV2.fatThickness_contemporary = epdDD.fatThickness_contemporary ? epdDD.fatThickness_contemporary : this.epdV2.fatThickness_contemporary
          this.epdV2.marbling = epdDD.marbling
            ? epdDD.marbling
            : this.epdV2.marbling;
          // this.epdV2.marblingContGrp = epdDD.marbling_contemporary ? epdDD.marbling_contemporary : this.epdV2.marblingContGrp
  
          this.epdV2.carcassWeight = epdDD.carcass_weight
            ? epdDD.carcass_weight
            : this.epdV2.carcass_weight;
          // this.epdV2.carcassWeightContGrp = epdDD.carcass_weight_contemporary ? epdDD.carcass_weight_contemporary : this.epdV2.carcass_weight_contemporary
          this.epdV2.kphFat = epdDD.kph_fat ? epdDD.kph_fat : this.epdV2.kphFat;
          // this.epdV2.yieldGrade = epdDD.yield_grade?epdDD.yield_grade:this.epdV2.yield_grade
          // this.epdV2.yieldGradeContGrp = epdDD.yield_grade_contemporary ? epdDD.yield_grade_contemporary : this.epdV2.yieldGradeContGrp
          this.epdV2.yearlingManagementCode = epdDD.yearling_management_code
            ? epdDD.yearling_management_code
            : this.epdV2.yearlingManagementCode;
          // this.epdV2.carcassWeightUnit = epdDD.carcass_weight_unit ? epdDD.carcass_weight_unit : this.epdV2.carcassWeightUnit
          this.epdV2.ribEyeAreaUnit = epdDD.rib_eye_area_unit
            ? epdDD.rib_eye_area_unit
            : this.epdV2.ribEyeAreaUnit;
          this.epdV2.fatThicknessUnit = epdDD.fat_thickness_unit
            ? epdDD.fat_thickness_unit
            : this.epdV2.fatThicknessUnit;
          this.epdV2.kphFatUnit = epdDD.kph_fat_unit
            ? epdDD.kph_fat_unit
            : this.epdV2.kphFatUnit;
          this.epdV2.marblingUnit = epdDD.marbling_unit
            ? epdDD.marbling_unit
            : this.epdV2.marblingUnit;
          this.epdV2.sireId = epdDD.sire_id ? epdDD.sire_id : this.epdV2.sireId;
          this.epdV2.damId = epdDD.dam_id ? epdDD.dam_id : this.epdV2.damId;
          this.epdV2.weaningSex = epdDD.weaning_sex
            ? epdDD.weaning_sex
            : this.epdV2.weaningSex;
          this.epdV2.yearlingSex = epdDD.yearling_sex
            ? epdDD.yearling_sex
            : this.epdV2.yearlingSex;
          this.epdV2.carcassSex = epdDD.carcassSex
            ? epdDD.carcassSex
            : this.epdV2.carcassSex;
          this.epdV2.primaryBreed = epdDD.breed
            ? epdDD.breed
            : this.epdV2.primaryBreed;
          this.epdV2.secondaryBreed = epdDD.secondary_breed
            ? epdDD.secondary_breed
            : this.epdV2.secondaryBreed;
          this.epdV2.birthManagementCode = epdDD.management_code
            ? epdDD.management_code
            : this.epdV2.birthManagementCode;
          // this.epdV2.managementPastureCode = epdDD.pasture_code
          //   ? epdDD.pasture_code
          //   : this.epdV2.managementPastureCode;
          this.epdV2.feedingCode = epdDD.feeding_code
            ? epdDD.feeding_code
            : this.epdV2.feedingCode;
          this.epdV2.breederHerdCode = epdDD.breeder_herd_code
            ? epdDD.breeder_herd_code
            : this.epdV2.breederHerdCode;
  
  
        }
      },
      async updateAnimalEPDSubmitStatus() {
        if (this.action == "create" && !this.formSubmited) {
          await this.submitForm();
        }else{
          // this.startLoading();
          EPDService.updateAnimalSubmitStatus([this.animal.id])
            .then((res) => {
              if (!res.success) throw res.message;
              this.$notify({
                title: "Record updated successfully.",
                text: res.message,
                type: "success",
              });
              // this.stopLoading();
            })
            .catch((err) => {
              this.formSubmited = false;
              if (typeof err === "string" || err instanceof String) {
                this.errorMsg = err;
              } else {
                this.errorMsg =
                  err?.data?.message ||
                  "Something went wrong! Please try after sometime.";
              }
              this.dataSubType = true;
              // this.stopLoading();
            });
        }
        
      },
    },
    mixins: [loadingMixin],
  };
  </script>
  
  <style scoped>
  .expansion-header {
    border: 1px solid #ffb443 !important;
    background-color: #fff7ec !important;
  }
  
  ::v-deep .required-field .v-input__slot {
    border: 1px solid #ffb443 !important;
    background-color: #fff7ec !important;
  }
  
  .expansion-close {
    background-color: #9695943a !important;
    border-radius: 0px !important;
  }
  
  .label {
    margin-bottom: 20px !important;
  }
  
  .v-application .subtitle-1 {
    font-size: 13px !important;
    font-weight: normal;
    letter-spacing: 0.009375em !important;
    line-height: 1.75rem;
    font-family: "Roboto", sans-serif !important;
  }
  
  .note {
    background-color: #fff7ec !important;
  }
  
  .no-border {
    border-left: none !important;
  }
  
  ::v-deep .v-stepper__step__step {
    height: 32px !important;
    min-width: 32px !important;
    font-size: 1rem !important;
  }
  
  ::v-deep .vertical-steps {
    flex-direction: row !important;
  }
  
  /* ::v-deep header.topbar-border .v-toolbar__content{
      border-bottom: 1px solid red !important;
  } */
  
  ::v-deep .v-stepper--vertical .v-stepper__content {
    padding: 16px 60px 0px 23px !important;
  }
  </style>